import { render, staticRenderFns } from "./PageFullwidth.vue?vue&type=template&id=8a1290e0"
import script from "./PageFullwidth.vue?vue&type=script&lang=js"
export * from "./PageFullwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports